(function() {

  var RETURN_TO = {

    init: function() {
      RETURN_TO.actions.conditionallyInsertReturnTo();
    },

    actions: {

      getReturnToParamValue: function() {
        
        try {
          var params = new URLSearchParams(document.location.search);
          return params.get("return_to");
        } catch (err) {
          console.warn("Error getting return to param.", err);
          return null;
        }
        
      },

      buildReturnToInput: function(inputValue) {

        var returnToInput = document.createElement("input");

        returnToInput.setAttribute("type", "hidden");
        returnToInput.setAttribute("name", "return_to");
        returnToInput.value = inputValue;

        return returnToInput;
        
      },

      conditionallyInsertReturnTo: function() {

        var loginForm = document.querySelector("#customer_login");
        var returnToValue = RETURN_TO.actions.getReturnToParamValue();

        console.log(loginForm, returnToValue);

        if (!loginForm || !returnToValue) {
          return;
        }

        var returnToInput = RETURN_TO.actions.buildReturnToInput(returnToValue);
        loginForm.append(returnToInput);
        
      }
      
    }
    
  };

  document.addEventListener("DOMContentLoaded", function() {
    RETURN_TO.init();
  });

})();
